import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, ButtonBase } from "@material-ui/core";
import CustomVolumeUpIcon from "liveShopping/assets/icons/CustomVolumeUpIcon";
import VolumeMute from "react-bootstrap-icons/dist/icons/volume-mute";
import { useDispatch, useSelector } from "react-redux";
import { setPlayerVolume } from "liveShoppingDucks/actions";
import Tooltip from "./Tooltip";
import { _t } from "utilities/i18n";
import { currentWizSelector } from "app/state/ducks/ressources/selectors";
const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "99px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 35,
    height: 35,
    marginTop: "5px",
  },
  boxMuted: {
    width: 35,
    height: 35,
    borderRadius: "99px",
    backgroundColor: theme.palette.colors.white,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const Volume = ({}) => {
  const classes = useStyles({});
  const dispatch = useDispatch();
  const wiz = useSelector(currentWizSelector);
  const playerVolume = useSelector((state) => state.liveShopping.playerVolume);

  const [clickedOnce, setClickedOnce] = useState(false);

  const handleMute = (mute) => {
    setClickedOnce(true);
    dispatch(setPlayerVolume(mute ? 0 : 1));
  };

  if (wiz.status === "awaiting_replay") return null;

  return (
    <ButtonBase id="muteUnmuteButton" className={classes.root}>
      {playerVolume === 1 ? (
        <CustomVolumeUpIcon color={"#FFF"} onClick={() => handleMute(true)} />
      ) : (
        <Box onClick={() => handleMute(false)}>
          {!clickedOnce && <Tooltip message={_t("Activate sound")} />}
          <Box className={classes.boxMuted}>
            <VolumeMute size={30} color={"black"} />
          </Box>
        </Box>
      )}
    </ButtonBase>
  );
};

Volume.propTypes = {};

Volume.defaultProps = {};

export default Volume;
